import PropTypes, { element } from 'prop-types';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';

// project imports
import NavItem from '../NavItem';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import fetchClient from 'views/utilities/RestfulAPI';
import router from 'routes/router';
import { IconChevronDown, IconChevronUp } from '@tabler/icons';

// ==============================|| SIDEBAR MENU LIST COLLAPSE ITEMS ||============================== //

const NavCollapse = ({ menu, level, handleHover, openDrawer, handMouseLeave, selectedID }) => {
    // console.log('menu -------', menu);
    const largeScreen = useMediaQuery('(min-width: 1200px)');

    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const [check , setCheck] = useState(true);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);

    const handleClick = () => {
        setOpen(!open);
        setSelected(!selected ? menu.id : null);
        handMouseLeave();
    };

    const getRoleService = async () => {
        const obj = {
            screen: 'service'
        };
        const res = await fetchClient.postRequest(router.SUB_URL.getPermisionByScreen, obj);
        console.log('res ------', res);
        return true;
    } 

    useEffect(() => {
        // let check = true;
        // console.log('');
        // if (menu.id === '/cau-hinh/dich-vu') {
        //     check = getRoleService()
        // }
        
        // console.log("useEffect selected", selected)
        const rsFilter = menu.children
            .filter((item) => item.id === document.location.pathname);
        if (rsFilter && rsFilter.length) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, []);

    // menu collapse & item
    const menus = menu.children?.map((item) => {
        switch (item.type) {
            case 'collapse':
                return (
                    <NavCollapse 
                        open={open} 
                        openDrawer={openDrawer} 
                        key={item.id} 
                        menu={item} 
                        level={level + 1} 
                        selectedID={selectedID} 
                    />
                );
            case 'item':
                return (
                    <NavItem
                        open={openDrawer}
                        key={item.id}
                        item={item}
                        level={level + 1}
                        handleHover={handleHover}
                        handMouseLeave={handMouseLeave}
                        // show = {check && item.id !== '/cau-hinh/dich-vu'}
                    />
                );
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    const Icon = menu.icon;
    const menuIcon = menu.icon ? (
        <Icon strokeWidth={1.5} size="1.3rem" />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width: selected === menu.id ? 8 : 6,
                height: selected === menu.id ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    return (
        <>
            <ListItemButton
                disabled={!largeScreen && !menu.spMobile}
                sx={{
                    borderRadius: `${customization.borderRadius}px`,
                    mb: 0.5,
                    alignItems: 'flex-start',
                    backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                    py: level > 1 ? 1 : 1.25,
                    pl: !openDrawer ? '20px' : `${level * 23}px`,
                    justifyContent: open ? 'initial' : 'center',
                    transform: `translateX(${open && !openDrawer ? '-12px' : '0px'})`
                }}
                // selected={selected === menu.id}
                onClick={handleClick}
                onMouseOver={handleHover}
            >
                <ListItemIcon sx={{ my: 'auto' }}>{menuIcon}</ListItemIcon>
                <ListItemText
                    primary={
                        <Typography
                            variant={selected === menu.id ? 'h5' : 'body1'}
                            color="inherit"
                            sx={{
                                px: '3.5px'
                            }}
                        >
                            {menu.title}
                        </Typography>
                    }
                    secondary={
                        menu.caption && (
                            <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                {menu.caption}
                            </Typography>
                        )
                    }
                />
                {open ? (
                    <IconChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                ) : (
                    <IconChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                )}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                    component="div"
                    disablePadding
                    sx={{
                        position: 'relative',
                        '&:after': {
                            content: "''",
                            position: 'absolute',
                            left: '20px',
                            top: 0,
                            height: '100%',
                            width: '1px',
                            opacity: 1
                            // background: theme.palette.primary.light
                        }
                    }}
                >
                    {menus}
                </List>
            </Collapse>
        </>
    );
};

NavCollapse.propTypes = {
    menu: PropTypes.object,
    level: PropTypes.number
};

export default NavCollapse;
